import axios from 'axios';

const API_BASE_URL = "https://api.eagleskylinesolutions.co.ke";

export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json"
    }
});

const getTenantKey = (): string => {
    const hostname = window.location.hostname;

    if (hostname.includes("eagleskylinesolutions.co.ke")) {
        return "ecommerce";
    }

    return "power";
};

// Axios Request Interceptor
api.interceptors.request.use(
    (config) => {
        // 1. Attach Tenant Header dynamically based on domain
        config.headers["X-Tenant-ID"] = getTenantKey();

        // 2. Attach JWT token if user is logged in
        const token = localStorage.getItem("jwt");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;